<div class="default-dialog-layout">
    <div class="title">Save Selection</div>

    <div class="content">
        <form #saveSelectionForm (ngSubmit)="confirm(selectionSaveName.value)">
            <cds-form-group layout="horizontal">
                <cds-input>
                    <label>Selection Name</label>
                    <input #selectionSaveName required type="text" />
                </cds-input>
            </cds-form-group>
            <div class="actions action-buttons form-action-buttons">
                <cds-button size="sm" type="button" action="flat" (click)="cancel()"
                    >Cancel</cds-button
                >
                <cds-button size="sm" [disabled]="!saveSelectionForm.checkValidity()" type="submit">
                    Save
                </cds-button>
            </div>
        </form>
    </div>
</div>
